export const OBSERVATORY = {
    name: 'CosmicLens Observatory',
    latitude: 51.1513,
    longitude: -3.5654,
    elevation: 420,
    timeZone: 'Europe/London',
    addressLines: ['Hollowmoor Ridge', 'Wheddon Cross, Exmoor', 'Somerset, England'],
    directionsUrl: 'https://www.google.com/maps/dir/?api=1&destination=51.1513,-3.5654'
}

export const OPENING_HOURS = [
    { days: 'Tuesday to Sunday', hours: '10:00 to 17:00', note: 'Planetarium, exhibition and café' },
    { days: 'Thursday to Saturday', hours: 'until 23:30', note: 'Late shows and the roof deck' },
    { days: 'Monday', hours: 'Closed', note: 'Except bank holidays' }
]

export const formatCoordinate = (value: number, positive: string, negative: string): string => {
    const abs = Math.abs(value)
    const degrees = Math.floor(abs)
    const minutesFloat = (abs - degrees) * 60
    const minutes = Math.floor(minutesFloat)
    const seconds = Math.round((minutesFloat - minutes) * 60)

    return `${degrees}° ${String(minutes).padStart(2, '0')}′ ${String(seconds).padStart(2, '0')}″ ${value >= 0 ? positive : negative}`
}
